import React from 'react'
import Sidebar from '../sidebar/sidebar'
import image from "../../assets/images/swap-kart-min.png"

const Swapkart = () => {
  return (
   <>
    <div className="home-container">
      <Sidebar/>
      <div className="home-content">
        <img
              src={image} // Replace with your image URL
          alt="Clients"
          className="home-image"
        />
      </div>
    </div>
   </>
  )
}

export default Swapkart